import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { skillQueryKeys } from "./skillQueryKeys";

export function useSkillVersions(skillId: string | undefined) {
  const { skillService } = useDomainServices();

  return useQuery({
    queryKey: skillQueryKeys.versions(skillId),
    queryFn: ({ signal }) =>
      skillService.listVersions(skillId!, { abortSignal: signal }),
    enabled: skillId !== undefined,
    staleTime: 30_000,
  });
}
